import {DialogData, DialogValidationComponent} from '@Common/widgets/general/dialog-validation';
import {SnackBarToastyService, typeToast} from '@Common/widgets/general/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {DarDossiersService} from '../services/dossiers/dossiers.service';
import {DataTableComponent} from '@Common/widgets/general/data-table';
import {Dossiers, TransitionEnum} from '../services';
import {SubSink} from '@Common/core/utils/subsink';
import {Individu, IndividuService} from '@Common/core/services';

/**
 * Helper pour des listes de dossier, fonctions utiles
 */
export abstract class ListDossiersHelper {
  subSink = new SubSink();
  connecte: Individu = null;
  protected constructor(public dialog: MatDialog,
                        public individuSvc: IndividuService,
                        public snackSvc: SnackBarToastyService,
                        public dossiersService: DarDossiersService) {
    this.subSink.sink = this.individuSvc.individu$.subscribe((_individu) => this.connecte = _individu);
  }

  /**
   * Action delete : doit-on la cacher ?
   * @param dossier
   */
  abstract hiddenActionDelete(dossier: Dossiers): boolean;
  /**
   * Confirmation et suppression d'un dossier
   * @param {Dossiers} dossier
   * @param {DataTableComponent} dataTable
   * @param {string} action : delete | archive
   * @protected
   */
  protected confirmAndDeleteDossier(dossier: Dossiers,
                                    dataTable: DataTableComponent,
                                    action: 'archive' | 'delete') {
    const data = new DialogData();
    const title = {
      delete: 'Suppression de dossier en création',
      archive: 'Classement sans suite du dossier'
    };
    const message = {
      delete: `Vous êtes sur le point de supprimer ce dossier <strong>${dossier.reference ? dossier.reference : ''}</strong> (en cours de création).
               <br/>Il ne sera plus possible de le retrouver par la suite.
               <br/>Confirmez-vous la suppression ?`,
      archive: `Vous êtes sur le point de classer sans suite ce dossier <strong>${dossier.reference ? dossier.reference : ''}</strong>.
                <br/>Vous pouvez indiquer une raison dans la zone de saisie ci dessous.
                <br/>Confirmez-vous le classement sans suite ?`
    };
    data.title = title[action];
    data.message = message[action];
    data.content = (action === 'archive');

    const dialogRef = this.dialog.open(DialogValidationComponent, { data: data });
    dialogRef.updatePosition({top: '50px'});
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (action === 'delete') {
          this.dossiersService.delete(dossier, 'uuid').subscribe((d) => {
            this.snackSvc.toasty('Dossier', 'Le dossier a bien été supprimé', typeToast.success);
            dataTable.reload();
          });
        }
        if (action === 'archive') {
          const msg = result.contentData || 'Raison inconnue';
          this.dossiersService.changeStateToArchive(dossier.uuid, msg).subscribe( (d) => {
            this.snackSvc.toasty('Dossier', 'Le dossier a été classé sans suite', typeToast.success);
            dataTable.reload();
          });
        }
      }
    });
  }
}
